// src/utils/createDataURL.js

const createDataURL = (
  text,
  bgColor = '#007bff',
  textColor = '#ffffff',
  width = 200,
  height = 200
) => {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext('2d');

  // Fill background
  ctx.fillStyle = bgColor;
  ctx.fillRect(0, 0, width, height);

  // Set proportional font size (about 25% of image height)
  const fontSize = Math.floor(height * 0.25);
  ctx.fillStyle = textColor;
  ctx.font = `bold ${fontSize}px Arial`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  // Draw text in center
  ctx.fillText(text, width / 2, height / 2);

  // Return base64 data URL
  return canvas.toDataURL();
};

export default createDataURL;
